import { BaseService } from './baseService';

class ApiKeysService extends BaseService<ApiKey, 'apiKeyID', 'apiKeys'> {
    constructor() {
        super('apiKeyID', 'apiKey', 'apiKeys');
    }
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new ApiKeysService();
